export class UnexpectedError extends Error {
    constructor() {
        super("An unexpected error has occurred, please try again later.");
    }
}
